import { makeRequest } from '../../../lib/api';

const FEEDBACK_PATH = '/v1/console_feedback';

class feedbackController {
  // okStatus = 201: backend возвращает CREATED при успешной отправке обращения
  create = (request) => {
    return makeRequest('post', FEEDBACK_PATH, request, undefined, 201);
  };

  getList = () => {
    return makeRequest('get', FEEDBACK_PATH);
  };

  // Свои обращения текущего пользователя (доступно любому авторизованному).
  getMy = () => {
    return makeRequest('get', `${ FEEDBACK_PATH }/my`);
  };

  getCategories = () => {
    return makeRequest('get', `${ FEEDBACK_PATH }/categories`);
  };

  getStatuses = () => {
    return makeRequest('get', `${ FEEDBACK_PATH }/statuses`);
  };

  updateStatus = (id, status) => {
    return makeRequest('patch', `${ FEEDBACK_PATH }/${ id }/status`, { status });
  };

  updateHandlerComment = (id, handlerComment) => {
    return makeRequest('patch', `${ FEEDBACK_PATH }/${ id }/handler_comment`, { handlerComment });
  };
}

export default new feedbackController();
